module.exports = __webpack_public_path__ + "img/female_introduction_1.30078f7d.png";